import { useLocation, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/features/auth/hooks/use-auth";
import { IconLoader2 } from "@tabler/icons-react";

export function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Don't redirect while still loading
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <IconLoader2 size={24} className="animate-spin text-medium" />
      </div>
    );
  }

  // If not authenticated, redirect to login but save the current location
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated, render the children routes via Outlet
  return <Outlet />;
}
